import './common.js'; 
import '../css/cricketers.css';
import { showHandicapModal } from './index.js';
import { refreshLeaderboard } from './listeners.js';

//import { doc } from 'firebase/firestore';
document.addEventListener('DOMContentLoaded', () => {
fetch("menu.html")
    .then(res => res.text())
    .then(data => {
    document.getElementById("menu-placeholder").innerHTML = data;
    })
    
fetch("clubModal.html")
    .then(res => res.text())
    .then(html => document.getElementById("shared-modals").innerHTML = html);



})
document.addEventListener('DOMContentLoaded', () => {
const tblBody = document.querySelector('#cricketTableBody');

if (tblBody) {
  tblBody.addEventListener('click', (e) => {
   
    const td = e.target.closest('td');
    if (!td || td.cellIndex !== 0) return;

    const name = td.innerText.split('(')[0].trim();
    showHandicapModal(name);
  });
}

 /*
  const datenow = new Date();
  let day = ("0" + datenow.getDate()).slice(-2);
  let month = ("0" + (datenow.getMonth() +1)).slice(-2) ;
  let year = datenow.getFullYear();
  let currentDate = `${day}-${month}-${year}`;
 */

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const formatted = `${yyyy}-${mm}-${dd}`;
  //populateLeaderBoard(currentDate);
  
  let teesOfTheDay = localStorage.getItem('tees');
  const teeSelect = document.getElementById('teeSelect')
  teeSelect.value = teesOfTheDay && teesOfTheDay.trim() !== "" 
  ? teesOfTheDay 
  : "yellow";
  const date = localStorage.getItem('date');
  document.getElementById('getdate').innerText  = date;
  document.getElementById('getdates').innerText  = date;
  document.getElementById('leaderboardDate').value = formatted;
  
})
document.getElementById("leaderboardDate").addEventListener("change", () => {
  const dateInput = document.getElementById("leaderboardDate").value;
  if (!dateInput) {
    alert("Please pick a date!");
    return; 
  }
  const [year, month, day] = dateInput.split("-");
  const dateStr = `${day}-${month}-${year}`;
  document.getElementById('getdates').innerHTML = dateStr;
  refreshLeaderboard(dateStr); // call your function
});

const addScores = document.querySelector('.showCricketLeaderBoard')
if (addScores) {
addScores.addEventListener('click', async (e)=> {
  e.preventDefault();
  
  document.getElementById('selCricketLeaderBoard').style.display='block';
  document.getElementById('selCricketers').style.display='none';
});
}
const addCrickter = document.querySelector('.addaCricketer')
if (addCrickter) {
addCrickter.addEventListener('click', (e)=> {
  e.preventDefault();
 
  document.getElementById('addCrickter').style.display='block';
  document.getElementById('selCricketers').style.display='none';
})
};
// Add a new row for player input
const addBtn = document.getElementById('add-player-btn');
  if (addBtn) {
    addBtn.addEventListener('click', addPlayer);
  }
function addPlayer() {
  const container = document.getElementById('playerInputs');
  const div = document.createElement('div');
  div.classList.add('playerRow');
  div.innerHTML = `
    <input type="text" placeholder="Player Name" name="name" required />
    <input style="width:25%;" type="number" placeholder="WHS Hcp" name="handicap" step="0.1" required />
    <button type="button" class="btn" onclick="removePlayer(this)" aria-label="Remove">Remove</button>
  `;
  container.appendChild(div);
}

// Remove a player row
window.removePlayer = function removePlayer(button) {
  button.parentElement.remove();
}

// Handle form submission
document.getElementById('playerForm').addEventListener('submit', async (e) => {
  e.preventDefault();
  window.addCricketer();
  
});

  const toLeaders = document.querySelector('.backToScoreEntry')
  toLeaders.addEventListener('click', (e)=> {
    e.preventDefault();
    document.getElementById('selCricketLeaderBoard').style.display='none';
    document.getElementById('selCricketers').style.display='block';
  });
  const toLeader = document.querySelector('.backToScore')
  toLeader.addEventListener('click', (e)=> {
    e.preventDefault();
    document.getElementById('addCrickter').style.display='none';
    document.getElementById('selCricketers').style.display='block';
  });
const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);
    document.getElementById('selCricketLeaderBoard').style.display = searchParams.get('l') === "true" ? "block" : "none";
    document.getElementById('selCricketers').style.display = searchParams.get('l') === "true" ? "none" : "block";

  

